import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useScrollToTop } from '../../../../../hooks/useScrollToTop';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import AvailableBookingPages from '../AvailableBookingPageList';
import css from './index.module.scss';

interface ElementProps {
  settings: IPurchases.SettingCompletion;
}

type Props = ElementProps;

const Subscribed: FC<Props> = (props: Props) => {
  const {
    settings: { bookingPages },
  } = props;
  useScrollToTop();
  const intl = useIntl();
  return (
    <div className={css.Subscribed}>
      <div className={css.Subscribed__MessageSection}>
        <p className={css.Subscribed__MessageTitle}>
          {intl.formatMessage({ id: `purchases.subscribed.title` })}
        </p>
        <p className={css.Subscribed__MessageParagraph}>
          {intl.formatMessage({
            id: `purchases.subscribed.message1`,
          })}
        </p>
      </div>
      {bookingPages.length !== 0 && (
        <AvailableBookingPages bookingPages={bookingPages} />
      )}
    </div>
  );
};

export default Subscribed;
